import animateOnScroll from "./animateOnScroll"

animateOnScroll([
	{ selector: ".fp-facts .fade-in-bottom", offset: 0.2, multiple: true }
]);
